<div class="is-block options-funding">
    @if (isRenew && !isFam) {
        <div class="field">
            <div class="control radio-animco is-horizontal">
                <label for="item-animation" class="radio-label">
                    <div class="sticker is-small is-secondary fanion-new">BON À SAVOIR</div>
                    <div class="has-text-tertiary has-text-left">
                        <p class="text is-level-3 is-marginless">
                            Bénéficiez d'un prix avantageux sur ce téléphone en changeant de forfait à l'étape suivante.
                        </p>
                    </div>
                </label>
            </div>
        </div>
    }
    @for (funding of fundings; track funding; let index = $index) {
        <div class="field is-multiline">
            <div class="control radio-tile is-horizontal">
                <input
                    type="radio"
                    id="item-{{ index }}"
                    name="example"
                    value="funding.type"
                    (click)="selectFunding(funding.type)"
                    [checked]="selectedFundingOption === funding.type"
                />
                <label for="item-{{ index }}" class="radio-label">
                    <div>
                        @if (funding.type.includes('YOUNITED')) {
                            <div class="sticker is-small is-secondary fanion-new">Nouveau</div>
                        }
                        <span class="radio-title">{{ funding.label }}</span>
                        <div class="has-text-tertiary has-text-left">
                            <p class="text is-level-2 is-marginless">
                                <trg-price
                                    [isInlined]="true"
                                    [hasPeriod]="false"
                                    [price]="funding.apportInitialOdr"
                                    [isWithoutTax]="isWithoutTax"
                                    class="funding-config-price"
                                ></trg-price>
                                {{
                                    funding.apportInitialOdr === funding.apportInitial
                                        ? "aujourd'hui"
                                        : 'après remboursement'
                                }}
                            </p>
                            @if (funding.montantMensualite > 0) {
                                <p class="text is-level-3 is-marginless">
                                    +
                                    <trg-price
                                        [isInlined]="true"
                                        [hasPeriod]="false"
                                        [price]="funding.montantMensualite"
                                        class="funding-config-price"
                                    ></trg-price>
                                    /mois pendant {{ funding.nbrEcheances }} mois
                                </p>
                            }
                        </div>
                    </div>
                </label>
            </div>
        </div>
    }
</div>
